// third-party

import { createSlice } from '@reduxjs/toolkit';

// project imports
import http from '@/app/http-common-admin';
import httpStudents from '@/app/http-common-students';
import httpProfrssors from '@/app/http-common-professors';
import httpCandidatures from '@/app/http-common-candidatures';

import { dispatch } from '../index';
import FacultyService from '@/app/services/admin/Faculty.service';
import DepartamentoServices from '@/app/services/admin/Departamento.services';
import UserService from '@/app/services/admin/User.service';
import { fetchUniversitiesAndCount } from '@/app/indexDB/UniversityIDB';
import { fetchFacultiesAndCount, insertFacultyToDB } from '@/app/indexDB/FacultyIDB';
import {dashboarResumegetAllTurnoID} from '@/app/services/admin/DashboardResume.services';
import { fetchDepartmentsAndCount } from '@/app/indexDB/departmentIDB';
import { utilisateurFsvorisGetAll, utilisateurFsvorisGetAllStudents } from '@/app/services/admin/UtilisateurFsvoris.services';
import { uniteEnseignementGetall, uniteEnseignementListFx } from '@/app/services/admin/UniteEnseignement.services';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    anneAcademiqueTable: [],
    paramMemoire: [],
    studentCoursTable: [],
    studentYearTable: [],
    studentPaymentCaisse: [],
    universityTable:[],
    facultyTable:[],
    facultyTableAllUser:[],

    facultyTableForConfigOnly:[],


    departamentoTable:[],
    departamentoTableAllData:[],

    turnoTable:[],
    academicYearTable:[],
    turmaTable:[],
    paymentsmouvements:[],
    userImageURL: "",
    soldeStudentTable: [],
    currencyTable: [],
    anneAcademiqueInscriptionTable: [],
    feeAllInscriptionOnline: [],
    studentTableAllUniversity: [],

    coursProfTable: [],
    coursTable: [],

    typeAvaliationTable:[],
    couraDurationTable:[],

    courUsuarioTable:[],

    calendarioGetAvaliation:[],

    userTable:[],
    userTableAdministracao:[],

    dashboardTurnoIdTable:[],
    dashboardDepartementTurnoIdTable:[],
    dashboardPagamentos7diasTable:[],
    dashboardPagamentosDoDiaTable:[],

    userTableProfessor:[],

    userFavoriteTable:[],
    uniteenseignnementTableall:[],

};

const slice = createSlice({
    name: 'diversStateManagement',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        getAnneeAcademiqueSucess(state, action) {
            state.anneAcademiqueTable = action.payload;
        },

        getParamMemoire(state, action) {
            state.paramMemoire = action.payload;
          },

          getStudentCours(state, action) {
            state.studentCoursTable = action.payload;
          },

          getStudentYearTab(state, action) {
            state.studentYearTable = action.payload;
          },

          getPaymentCaisse(state, action) {
            state.studentPaymentCaisse = action.payload;
          },

          getUniversity(state, action) {
            state.universityTable = action.payload;
          },

          getFaculty(state, action) {
            state.facultyTable = action.payload;
          },

          getFacultyAllUser(state, action) {
            state.facultyTableAllUser = action.payload;
          },

          getFacultyForConfigOnly(state, action) {
            state.facultyTableForConfigOnly = action.payload;
          },


          getDepartment(state, action) {
            state.departamentoTable = action.payload;
          },

          getDepartmentAllData(state, action) {
            state.departamentoTableAllData = action.payload;
          },

          
          getTurno(state, action) {
            state.turnoTable = action.payload;
          },

          getAcademicYear(state, action) {
            state.academicYearTable = action.payload;
          },

          getTurma(state, action) {
            state.turmaTable = action.payload;
          },

          getPaymentsmouvements(state, action) {
            state.paymentsmouvements = action.payload;
          },

          setImageUrl(state, action) {
            state.userImageURL = action.payload;
          },

          getSolde(state, action) {
            state.soldeStudentTable = action.payload;
          },

          getCurrency(state, action) {
            state.currencyTable = action.payload;
          },

          getAnneeAcademiqueInscription(state, action) {
            state.anneAcademiqueInscriptionTable = action.payload;
        },

        getAllFeesInscriptonOnline(state, action) {
            state.anneAcademiqueInscriptionTable = action.payload;
        },

        getAllFeesInscriptonOnline(state, action) {
            state.feeAllInscriptionOnline = action.payload;
        },

        getAllStudentsUniversity(state, action) {
            state.studentTableAllUniversity = action.payload;
        },

        getAllCoursProf(state, action) {
            state.coursProfTable = action.payload;
        },

        getAllCours(state, action) {
            state.coursTable = action.payload;
        },


        
        getTypeAvaliation(state, action) {
            state.typeAvaliationTable = action.payload;
        },

        getCAllCoursDuration(state, action) {
            state.couraDurationTable = action.payload;
        },

        getCursoUsuario(state, action) {
            state.courUsuarioTable = action.payload;
        },

        getAvaliationData(state, action) {
            state.calendarioGetAvaliation = action.payload;
        },

        getAllUsers(state, action) {
            state.userTable = action.payload;
        },

        getAllUsersAdministracao(state, action) {
            state.userTableAdministracao = action.payload;
        },
        getUserFavoriteAll(state, action) {
            state.userFavoriteTable = action.payload;
        },

        

        getAllUsersProfessor(state, action) {
            state.userTableProfessor = action.payload;
        },

        

        getDashboardTurnoID(state, action) {
            state.dashboardTurnoIdTable = action.payload;
        },

        getDashboardDepartementTurnoID(state, action) {
            state.dashboardDepartementTurnoIdTable = action.payload;
        },

        getDashboardPagamentosInteerval7Dias(state, action) {
            state.dashboardPagamentos7diasTable = action.payload;
        },

        getDashboardPagamentosdoDia(state, action) {
            state.dashboardPagamentosDoDiaTable = action.payload;
        },

        getUniteenseignementData(state, action) {
            state.uniteenseignnementTableall = action.payload;
        },
        
        
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getresetState(state, action) {
    return async () => {
        try {
        
            dispatch(slice.actions.getParamMemoire([]));

            } catch (error) {
              //  console.log("error : annee academoque: ", error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllAnneeAcademique(typeDisplay, universityID) {
    return async () => {
        try {
            const response = await http.get(`/currentYear?typeDisplay=${typeDisplay}&universityID=${universityID}`);
             dispatch(slice.actions.getAnneeAcademiqueSucess(response.data));
            

            } catch (error) {
              //  console.log("error : annee academoque: ", error);
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAllAnneeAcademiqueStudents(typeDisplay, universityID) {
    return async () => {
        try {
            const response = await httpStudents.get(`/currentYear?typeDisplay=${typeDisplay}&universityID=${universityID}`);
             dispatch(slice.actions.getAnneeAcademiqueSucess(response.data));
            

            } catch (error) {
              //  console.log("error : annee academoque: ", error);
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function setParamMemoire(value) {
    return async (dispatch) => {
      try {  

        dispatch(slice.actions.getParamMemoire(value));
      } catch (error) {
        console.log("errorReducChecking###### ", error)
        dispatch(slice.actions.hasError(error));
      }
    };
  }

  export function getAllStudentCoursAccessEstudante(studentID) {
    return async () => {
        try {
            const response = await http.get(`/studentcours?studentID=${studentID}&tipoDisplay=${'studentCoursGetAllToutesLesAnnees'}`);
             dispatch(slice.actions.getStudentCours(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllStudentCoursAccessEstudantStudentApi(studentID) {
    return async () => {
        try {
            const response = await httpStudents.get(`/studentcours?studentID=${studentID}&tipoDisplay=${'studentCoursGetAllToutesLesAnnees'}`);
             dispatch(slice.actions.getStudentCours(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getYearStudentCoursDistinct(studentID, tipoDisplay) {
    return async () => {
        try {
            const response = await http.get(`/studentcours?studentID=${studentID}&tipoDisplay=${tipoDisplay}`);
             dispatch(slice.actions.getStudentYearTab(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getYearStudentCoursDistinctStudentApi(studentID, tipoDisplay) {
    return async () => {
        try {
            const response = await httpStudents.get(`/studentcours?studentID=${studentID}&tipoDisplay=${tipoDisplay}`);
             dispatch(slice.actions.getStudentYearTab(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPAymentCaisseStudent(studentMatriculaID, typeDisplay, year, DisplayType, universityID) {
    return async () => {

        try {
            const response = await http.get(`/paymentsMouvements?studentMatriculaID=${studentMatriculaID}&typeDisplay=${typeDisplay}&year=${year}&DisplayType=${DisplayType}&universityID=${universityID}`);
            
             dispatch(slice.actions.getPaymentCaisse(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPAymentCaisseStudentStudentApi(studentMatriculaID, typeDisplay, year, DisplayType, universityID) {
    return async () => {

        try {
            const response = await httpStudents.get(`/paymentsMouvements?studentMatriculaID=${studentMatriculaID}&typeDisplay=${typeDisplay}&year=${year}&DisplayType=${DisplayType}&universityID=${universityID}`);
            
             dispatch(slice.actions.getPaymentCaisse(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getUniversity(tipoPedido, userID, role) {
    return async (dispatch) => {  // Dispatch is passed here
        try {
            let filteredUniversities;

            if(Number(role) > 1 && Number(role) < 101) {
                const responseCoursUsuer = await http.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
                const allowedData = responseCoursUsuer.data;

                const response = await http.get(`/universities?tipoPedido=${tipoPedido}`);
                const allUniversities = response.data;

                filteredUniversities = allUniversities.filter(university =>
                    allowedData.some(allowed => allowed.universityID === university.id)
                );

                dispatch(slice.actions.getUniversity(filteredUniversities));
            } else {
                const response = await http.get(`/universities?tipoPedido=${tipoPedido}`);
                filteredUniversities = response.data;

                dispatch(slice.actions.getUniversity(response.data));
                await fetchUniversitiesAndCount(response.data);
            }

            return filteredUniversities;  // Returns a promise when awaited
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return Promise.reject(error);  // Ensures error is handled in Promise.all
        }
    };
}


/* export function getUniversity(tipoPedido, userID, role) {
    return async () => {
        
        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {
            
            // Fetching the allowed data of users
            const responseCoursUsuer = await http.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await http.get(`/universities?tipoPedido=${tipoPedido}`);
            const allUniversities = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredUniversities = allUniversities.filter(university =>
                allowedData.some(allowed => allowed.universityID === university.id)
            );

            // Dispatching action with filtered universities
            dispatch(slice.actions.getUniversity(filteredUniversities));
            
            }
            else {

                const response = await http.get(`/universities?tipoPedido=${tipoPedido}`);
              //   console.log("universityChec k##### ", response.data )
                  dispatch(slice.actions.getUniversity(response.data));
             
              //  console.log("checkingUniversityOnEntry#### ",response.data )
                await fetchUniversitiesAndCount(response.data);

            }

        } catch (error) {

            dispatch(slice.actions.hasError(error));
        }

    

    };
} */


export function getUniversityCandidatures(tipoPedido, userID, role) {
    return async () => {

        try {
           
                const response = await httpCandidatures.get(`/universities?tipoPedido=${tipoPedido}`);

                 dispatch(slice.actions.getUniversity(response.data));
            
               await fetchUniversitiesAndCount(response.data);

        } catch (error) {
         //   console.log("erroruniversity: ", error);

           // dispatch(slice.actions.hasError(error));
        }

    

    };
}

export function getUniversityProf(tipoPedido, userID, role) {
    return async () => {

        try {

                const response = await httpProfrssors.get(`/universities?tipoPedido=${tipoPedido}`);

                dispatch(slice.actions.getUniversity(response.data));
                
        } catch (error) {
          //  console.log("erroruniversity: ", error);

            dispatch(slice.actions.hasError(error));
        }

    

    };
}

export function getUniversityStudentApi(tipoPedido, userID, role) {
    return async () => {

        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {
            
            // Fetching the allowed data of users
            const responseCoursUsuer = await httpStudents.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await httpStudents.get(`/universities?tipoPedido=${tipoPedido}`);
            const allUniversities = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredUniversities = allUniversities.filter(university =>
                allowedData.some(allowed => allowed.universityID === university.id)
            );

            // Dispatching action with filtered universities
            dispatch(slice.actions.getUniversity(filteredUniversities));
            
            }
            else {

                const response = await httpStudents.get(`/universities?tipoPedido=${tipoPedido}`);
                dispatch(slice.actions.getUniversity(response.data));
                

            }


        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }

    };
}

export function getUniversityProfApi(tipoPedido, userID, role) {
    return async () => {

        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {
            
            // Fetching the allowed data of users
            const responseCoursUsuer = await httpProfrssors.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await httpProfrssors.get(`/universities?tipoPedido=${tipoPedido}`);
            const allUniversities = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredUniversities = allUniversities.filter(university =>
                allowedData.some(allowed => allowed.universityID === university.id)
            );

            // Dispatching action with filtered universities
            dispatch(slice.actions.getUniversity(filteredUniversities));
            
            }
            else {

                const response = await httpProfrssors.get(`/universities?tipoPedido=${tipoPedido}`);
                dispatch(slice.actions.getUniversity(response.data));
                

            }


        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }

    

    };
}


export function getFaculty(tipoDisplay,userID, role, universityID) {
    return async (dispatch) => {
        try {
            
            if(Number(role)  > 0   &&  Number(role)  < 101) 
            {

            const responseCoursUsuer = await http.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}&universityID=${universityID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            const allfaculties = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredFaculties = allfaculties.flat().filter(faculty =>
                allowedData.some(allowed => allowed.facultyID === faculty.id)
            );    

       //      console.log("2.llfaculties#################: ", allfaculties)


            // Dispatching action with filtered universities
             dispatch(slice.actions.getFaculty(filteredFaculties));
           
             dispatch(slice.actions.getFacultyAllUser(allfaculties));

            
             // //  await fetchFacultiesAndCount(filteredFaculties);
            
            }
            if(Number(role) === 101) 
            {

              // const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);

             const getData1 = await FacultyService.getAllLogin(tipoDisplay,  role, universityID);
           //   const response = await http.get(`/universities?tipoDisplay=${tipoDisplay}`);

           dispatch(slice.actions.getFaculty(getData1.data));
                 //  alert("uiuui77777")
                 dispatch(slice.actions.getFacultyAllUser(getData1.data));


              //    console.log("getData1.data#### " , getData1.data)
               //   await fetchFacultiesAndCount(getData1.data);
               
            }


        } catch (error) {
           // console.log("errorFaculty77777: ", error)
            dispatch(slice.actions.hasError(error));
        }


/* 
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getFaculty(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        } */
    };
}

export function getFacultyForConfigOnly(tipoDisplay, uniID) {

    return async (dispatch) => {
        try {

             const getData1 = await FacultyService.getAllForConfigOnly(tipoDisplay, uniID);


                  dispatch(slice.actions.getFacultyForConfigOnly(getData1.data));           

        } catch (error) {
            console.log("errorFaculty77777: ", error)
            dispatch(slice.actions.hasError(error));
        }


/* 
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getFaculty(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        } */
    };
}

export function getFacultyCandidatures(tipoDisplay,userID, role) {
    return async () => {

        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {

            const responseCoursUsuer = await httpCandidatures.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await httpCandidatures.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            const allfaculties = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredFaculties = allfaculties.filter(faculty =>
                allowedData.some(allowed => allowed.facultyID === faculty.id)
            );

            // Dispatching action with filtered universities
            dispatch(slice.actions.getFaculty(filteredFaculties));

            await fetchFacultiesAndCount(response.data);

            }else {
               
                
              // const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);

             const getData1 = await FacultyService.getAllLoginCandatures(tipoDisplay);
           //  console.log("getData1: ", getData1.data)

            
           //   const response = await http.get(`/universities?tipoDisplay=${tipoDisplay}`);

                 dispatch(slice.actions.getFaculty(getData1.data));
           
                 await fetchFacultiesAndCount(response.data);

            }


        } catch (error) {
           // console.log("errorFaculty77777: ", error)
            dispatch(slice.actions.hasError(error));
        }


/* 
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getFaculty(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        } */
    };
}

export function getFacultyCandidaturesRealCandidature(tipoDisplay,universityID) {
    return async () => {

        try {


            const response = await httpCandidatures.get(`/faculties?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            const allfaculties = response.data;

           
            // Dispatching action with filtered universities
            dispatch(slice.actions.getFaculty(allfaculties));


        } catch (error) {
           // console.log("errorFaculty77777: ", error)
            dispatch(slice.actions.hasError(error));
        }


/* 
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getFaculty(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        } */
    };
}
export function getFacultyProfApi(tipoDisplay) {
    return async () => {

        try {


                const response = await httpProfrssors.get(`/faculties?tipoDisplay=${tipoDisplay}`);
                 dispatch(slice.actions.getFaculty(response.data));

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }


/* 
            const response = await http.get(`/faculties?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getFaculty(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        } */
    };
}

export function gteDepartement(tipoDisplay, userID, role, universityID ) {
    return async (dispatch) => {

        try {

            if(Number(role)  > 0   &&  Number(role)  < 101) {



            const responseCoursUsuer = await http.get(`/users?tipoDisplay=${'coursoUsuarioGetAll_Department'}&userID=${userID}&universityID=${universityID}`);
            const allowedData = responseCoursUsuer.data;

        //    console.log("allowedData##########flatAllowedData### ", allowedData);


           
            // Fetching all data of the universities
           //  const flatAllowedData = allowedData.(); // Flatten if needed

           //  const flatAllowedData = allowedData.flat(); // Flatten if needed


            const response = await http.get(`/departments?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            const allfaculties = response.data;


         //    console.log("allfaculties##########flatAllowedData### ", allfaculties);

           
            // Filter universities to include only those that match universityID in the allowed user data
          
            
            const filteredFaculties = allfaculties.filter(department =>
                allowedData.some(allowed => Number(allowed.departmentID) === Number(department.id))
              );

              

         /*    const filteredDepartement = allfaculties.flat().filter(faculty =>
                allowedData.some(allowed => allowed.facultyID === faculty.id)
            );    */

           //  console.log("filteredFaculties##########departmenetGellRedux### ", filteredFaculties)


           //  flatAllowedData.forEach(allowed => console.log("6.Allowed departmentID:", allowed.departmentID));
           //  allfaculties.forEach(department => console.log("7.Department ID:", department.id));


            // Dispatching action with filtered universities

            dispatch(slice.actions.getDepartment(allowedData));
        
            dispatch(slice.actions.getDepartmentAllData(allowedData));
            
            }

                if( Number(role)  === 101) {

                const getData1 = await http.get(`/departments?tipoDisplay=${tipoDisplay}&userID=${userID}&universityID=${universityID}`);

               dispatch(slice.actions.getDepartmentAllData(getData1.data));

                dispatch(slice.actions.getDepartment(getData1.data));
            }

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }

/* 

            const response = await http.get(`/departments?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getDepartment(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error)); */
        
    };
}

export function gteDepartementCandidatures(tipoDisplay, userID, role ) {
    return async () => {

        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {

            const responseCoursUsuer = await httpCandidatures.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await httpCandidatures.get(`/departments?tipoDisplay=${tipoDisplay}`);
            const allfaculties = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
          
            
            const filteredFaculties = allfaculties.filter(faculty =>
                allowedData.some(allowed => allowed.departmentID === faculty.id)
            );

            // Dispatching action with filtered universities

            dispatch(slice.actions.getDepartment(filteredFaculties));

            }
            else {

                const getData1 = await DepartamentoServices.getAllLoginCandidatures(tipoDisplay);

                dispatch(slice.actions.getDepartment(getData1.data));
            }

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }

/* 

            const response = await http.get(`/departments?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getDepartment(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error)); */
        
    };
}

export function gteDepartementProfApi(tipoDisplay, userID, role ) {
    return async () => {

        try {

            if(Number(role)  > 1   &&  Number(role)  < 101) {

            const responseCoursUsuer = await httpProfrssors.get(`/users?tipoDisplay=coursoUsuarioGetAll&userID=${userID}`);
            const allowedData = responseCoursUsuer.data;

            // Fetching all data of the universities
            const response = await httpProfrssors.get(`/departments?tipoDisplay=${tipoDisplay}`);
            const allfaculties = response.data;

            // Filter universities to include only those that match universityID in the allowed user data
            const filteredFaculties = allfaculties.filter(faculty =>
                allowedData.some(allowed => allowed.departmentID === faculty.id)
            );

            // Dispatching action with filtered universities

            dispatch(slice.actions.getDepartment(filteredFaculties));

            }
            else {
                const response = await http.get(`/departments?tipoDisplay=${tipoDisplay}`);
            
                dispatch(slice.actions.getDepartment(response.data));
          
            }

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }

/* 

            const response = await http.get(`/departments?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getDepartment(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error)); */
    };
}

export function getTurno(tipoDisplay, universityID) {
    return async (dispatch) => {  // <-- Pass dispatch here
        try {

            const response = await http.get(`/turnos?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            
            dispatch(slice.actions.getTurno(response.data));  // Dispatch now correctly returns a promise
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return Promise.reject(error);  // Handle errors in Promise.all
        }
    };
}

/* export function getTurno(tipoDisplay) {
    return async () => {

        try {
            const response = await http.get(`/turnos?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getTurno(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
} */

export function getTurnoCandidatures(tipoDisplay, universityID) {
    return async () => {

        try {
            const response = await httpCandidatures.get(`/turnos?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            
             dispatch(slice.actions.getTurno(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTurnoProfApi(tipoDisplay) {
    return async () => {

        try {
            const response = await httpProfrssors.get(`/turnos?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getTurno(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAcademicYear(tipoDisplay, universityID) {
    return async (dispatch) => {

        try {
            const response = await http.get(`/academicyear?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
            
             dispatch(slice.actions.getAcademicYear(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAcademicYearCandidatures(tipoDisplay) {
    return async () => {

        try {
            const response = await httpCandidatures.get(`/academicyear?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getAcademicYear(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAcademicYearProfApi(tipoDisplay) {
    return async () => {

        try {
            const response = await httpProfrssors.get(`/academicyear?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getAcademicYear(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTurma(tipoDisplay) {
    return async (dispatch) => {

        try {
            const response = await http.get(`/turma?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getTurma(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTurmaProfApi(tipoDisplay) {
    return async () => {

        try {
            const response = await httpProfrssors.get(`/turma?tipoDisplay=${tipoDisplay}`);
            
             dispatch(slice.actions.getTurma(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPaymentsmouvements(studentMatriculaID, universityID, DisplayType) {
    return async () => {

        try {
            const response = await http.get(`/paymentsMouvements?studentMatriculaID=${studentMatriculaID}&universityID=${universityID}&DisplayType=${DisplayType}`);
            
             dispatch(slice.actions.getPaymentsmouvements(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPaymentsmouvementsStudentApi(studentMatriculaID, universityID, DisplayType) {
    return async () => {

        try {
            const response = await httpStudents.get(`/paymentsMouvements?studentMatriculaID=${studentMatriculaID}&universityID=${universityID}&DisplayType=${DisplayType}`);
            
             dispatch(slice.actions.getPaymentsmouvements(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}



export function setUserImagePath(value) {
    return async () => {
      try {  
        dispatch(slice.actions.setImageUrl(value));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }

  
export function getSaldoEstudent(universityID, studentNumber ) {
    return async () => {
        try {
            const response = await http.get(`/soldestudent?studentNumber=${studentNumber}&universityID=${universityID}`);
            
             dispatch(slice.actions.getSolde(response.data));
             return response.data; // Return the response data
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSaldoEstudentStudentApi(universityID, studentNumber ) {
    return async () => {
        try {
            const response = await httpStudents.get(`/soldestudent?studentNumber=${studentNumber}&universityID=${universityID}`);
            
             dispatch(slice.actions.getSolde(response.data));
             return response.data; // Return the response data
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export async function getSaldoEstudentNonRedux(universityID, studentNumber) {
    const response = await http.get(`/soldestudent?studentNumber=${studentNumber}&universityID=${universityID}`);
            
             return response.data; // Return the response data
}

export function getCurrencyAll(universityID, typeSearch) {
    return async () => {

        try {
            const response = await http.get(`/currency?universityID=${universityID}&typeSearch=${typeSearch}`);
            
             dispatch(slice.actions.getCurrency(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAllAnneeAcademiqueInscriptionOnline(typeDisplay, universityID) {
    return async () => {
        try {

            const response = await httpCandidatures.get(`/currentYearInscription?typeDisplay=${typeDisplay}&universityID=${universityID}`);
            
            dispatch(slice.actions.getAnneeAcademiqueInscription(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllAnneeAcademiqueInscription(typeDisplay, universityID) {
    return async () => {
        try {
            const response = await http.get(`/currentYearInscription?typeDisplay=${typeDisplay}&universityID=${universityID}`);
            
            dispatch(slice.actions.getAnneeAcademiqueInscription(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllAnneeAcademiqueInscriptionCandidatures(typeDisplay, universityID) {

    return async () => {
        try {

            const response = await httpCandidatures.get(`/currentYearInscription?typeDisplay=${typeDisplay}&universityID=${universityID}`);
             dispatch(slice.actions.getAnneeAcademiqueInscription(response.data));
             
            } catch (error) {
                console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFeeLieeAllForInscriptionEnLigne(id, tipoPedido) {
    return async () => {
        try {
            const response = await http.get(`/fees/${id}?tipoPedido=${tipoPedido}`);
             dispatch(slice.actions.getAllFeesInscriptonOnline(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFeeLieeAllForInscriptionEnLigneCandidatures(id, tipoPedido) {
    return async () => {
        try {
            const response = await httpCandidatures.get(`/fees/${id}?tipoPedido=${tipoPedido}`);
             dispatch(slice.actions.getAllFeesInscriptonOnline(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAllStudentDeUniversity(universityID, year) {
    return async () => {
        try {
            const response =  await http.get(`/students/getAllStudentDeUniversity?universityID=${universityID}&year=${year}`);

             dispatch(slice.actions.getAllStudentsUniversity(response.data));

            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}



export function getCoursProf(universityID, year, professeurID, tipoDisplay) {
    return async () => {

        try {
            const response = await  http.get(`/ProfCours?universityID=${universityID}&year=${year}&professeurID=${professeurID}&tipoDisplay=${tipoDisplay}`);

            dispatch(slice.actions.getAllCoursProf(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getCoursProfProfApi(universityID, year, professeurID, tipoDisplay) {
    return async () => {

        try {
            const response = await  httpProfrssors.get(`/ProfCours?universityID=${universityID}&year=${year}&professeurID=${professeurID}&tipoDisplay=${tipoDisplay}`);

            dispatch(slice.actions.getAllCoursProf(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getCoursDuration(tipoDisplay, universityID) {
    return async (dispatch) => {  // Pass dispatch as an argument
        try {

            const response = await http.get(`/coursDuration?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);

            dispatch(slice.actions.getCAllCoursDuration(response.data));  // Dispatch correctly
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            return Promise.reject(error);  // Return error for Promise.all
        }
    };
}

/*  
export function getCoursDuration(tipoDisplay, universityID) {
    return async () => {

        try {
            const response = await http.get(`/coursDuration?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);


             dispatch(slice.actions.getCAllCoursDuration(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
} */

export function getCoursDurationProfApi(tipoDisplay, universityID) {
    return async () => {

        try {
            const response = await httpProfrssors.get(`/coursDuration?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);

             dispatch(slice.actions.getCAllCoursDuration(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getCoursDurationStudentApi(tipoDisplay, universityID) {
    return async () => {

        try {
            const response = await httpStudents.get(`/coursDuration?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);

             dispatch(slice.actions.getCAllCoursDuration(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getCalendarioAvaliation(id, tipoPedido, universityID) {
    return async () => {

        try {
            const response = await http.get(`/calendarioiLancamentoNotas/${id}?tipoPedido=${tipoPedido}&universityID=${universityID}`)
            
             dispatch(slice.actions.getAvaliationData(response.data));
             
            } catch (error) {
                console.log("stopCalendario ", error)
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getCalendarioAvaliationProfApi(id, tipoPedido, universityID) {
    return async () => {

        try {
            const response = await httpProfrssors.get(`/calendarioiLancamentoNotas/${id}?tipoPedido=${tipoPedido}&universityID=${universityID}`)
            
             dispatch(slice.actions.getAvaliationData(response.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAllUser(tipoDisplay, universityID) {
    return async () => {

        try {

            const getData1 = await UserService.getAllLogin(tipoDisplay, universityID);

          //  const response = await http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
            
             dispatch(slice.actions.getAllUsers(getData1.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllUserAdministracao(tipoDisplay, universityID) {
    return async (dispatch) => { // Added dispatch as a parameter
    try {
    const getData1 = await UserService.getAllLogin(tipoDisplay, universityID);
    await dispatch(slice.actions.getAllUsersAdministracao(getData1.data)); // Added await for dispatch
    } catch (error) {
    await dispatch(slice.actions.hasError(error)); // Added await for dispatch
    }
    };
    }

/* export function getAllUserAdministracao(tipoDisplay, universityID) {
    return async () => {

        try {

            const getData1 = await UserService.getAllLogin(tipoDisplay, universityID);

          //  const response = await http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
            
        //   console.log("getData1.dataUserLoginChecj ### ", getData1.data)
          
          dispatch(slice.actions.getAllUsersAdministracao(getData1.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
} */

export function getAllUserFavorite(userID) {
    return async (dispatch) => {


        try {
            const getData1 = await utilisateurFsvorisGetAll(userID);

           
          //  const response = await http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
            
        //   console.log("getData1.dataUserLoginChecj ### ", getData1.data)
          
          dispatch(slice.actions.getUserFavoriteAll(getData1.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllUserFavoriteStudebts(userID) {
    return async (dispatch) => {


        try {
            const getData1 = await utilisateurFsvorisGetAllStudents(userID);

           
          //  const response = await http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
            
        //   console.log("getData1.dataUserLoginChecj ### ", getData1.data)
          
          dispatch(slice.actions.getUserFavoriteAll(getData1.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllUserProfesssor(tipoDisplay, universityID) {
    return async (dispatch) => {  // Added dispatch as a parameter
    try {
    const getData1 = await UserService.getAllLogin(tipoDisplay, universityID);
    await dispatch(slice.actions.getAllUsersProfessor(getData1.data, universityID)); // Used await here
    } catch (error) {
    await dispatch(slice.actions.hasError(error)); // Added await here too
    }
    };
    }

/* export function getAllUserProfesssor(tipoDisplay) {
    return async () => {

        try {

            const getData1 = await UserService.getAllLogin(tipoDisplay);

          //  const response = await http.get(`/users?tipoDisplay=${tipoDisplay}&universityID=${universityID}`)
            
             dispatch(slice.actions.getAllUsersProfessor(getData1.data));
             
            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
 */



export function dashboardAdminResumeTurnoID(year, universityID, tipoDisplay) {
    return async () => {

        try {

            const response = await dashboarResumegetAllTurnoID(year, universityID, tipoDisplay);

             dispatch(slice.actions.getDashboardTurnoID(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}



export function dashboardAdminResumeDepartementTurnoIDTotal(year, universityID, tipoDisplay) {
    return async () => {

        try {

            const response = await dashboarResumegetAllTurnoID(year, universityID, tipoDisplay);

             dispatch(slice.actions.getDashboardDepartementTurnoID(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}


export function dashboardAdminResumePagamento7DiaGet(year, universityID, tipoDisplay) {
    return async () => {

        try {

            const response = await dashboarResumegetAllTurnoID(year, universityID, tipoDisplay);

             dispatch(slice.actions.getDashboardPagamentosInteerval7Dias(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}


export function dashboardAdminResumePagamentoDoDia(year, universityID, tipoDisplay) {
    return async () => {

        try {

            const response = await dashboarResumegetAllTurnoID(year, universityID, tipoDisplay);

          //  console.log("response5555###### ", response.data);

             dispatch(slice.actions.getDashboardPagamentosdoDia(response.data));
             
            } catch (error) {
                console.log(error)

            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getAllUniteenseignementByUniveristy(typeDisplay,  universityID) {
    return async (dispatch) => {  // Added dispatch as a parameter
    try {
    const getData1 = await uniteEnseignementGetall(typeDisplay, universityID);
    await dispatch(slice.actions.getUniteenseignementData(getData1.data, universityID)); // Used await here
    } catch (error) {
    await dispatch(slice.actions.hasError(error)); // Added await here too
    }
    };
    }







  
  